export interface GetWillInvoicedListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetWillInvoicedListPagingAndFilterResponseData
}

export interface GetWillInvoicedListPagingAndFilterResponseData {
    items: GetWillInvoicedListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetWillInvoicedListPagingAndFilterResponseItem {
    orderId: string
    expectedIncomeOutcomeId: string
    refNo: string
    customerName: string
    customerId: string
    supplierName: string
    receiverFirm: any
    totalPriceWeight: number
    divisionId?: string
    divisionName?: string
    poId?: string
    poName?: string
    documentNo?: string
    shippingCode?: string
    totalWithoutTaxPrice: number
    currencyTypeName: string
    currencyTypeId: string
    totalPrice: number
    isSelected: boolean
    moduleKey: string
    poNo: string
    vehicleStatusName: string
    vehicleStatusKey: string
    isWithholding: boolean
}

export const initialGetWillInvoicedListPagingAndFilterResponseData: GetWillInvoicedListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}